import React from 'react';
import {useTransition, animated} from 'react-spring';
import PropTypes from 'prop-types';

const GalleryMount = ({toggle, target, set}) => {

    const GalleryStyle = useTransition(toggle, {
        from: {height:"100vh", width:"100vw", opacity:1, top:"-100vh"},
        enter: {opactiy:1, top:"0", pointerEvents: "auto"},
        leave: {opacity:0, top:"-100vh", pointerEvents: "none"},
        reverse: toggle,
    });

    return GalleryStyle((styles, item) => item && <animated.div style={{...styles}} className="gallery-info" onClick={() => set(false)}>
            <div className="container">
                <img src={target.image} alt={target.imageAlt} className="image"/>
                <div className="section">
                    <div className="stats">
                        <p>
                        {`Location: ${target.location}`}
                        </p>
                    </div>
                    <div className="description">
                            {target.description}
                    </div>  
                </div>
            </div>

        </animated.div>
    )
}

GalleryMount.propTypes = {
    toggle: PropTypes.bool,
    target: PropTypes.object,
}

export default GalleryMount;